import React from "react";
import { DirectionForm } from "./Forms/DirectionForm";
import { useCreateDirectionMutation } from "../../services/basicData/basicData";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { PageHeader } from "../../CommonElements/PageTitle";
import { Container, Form, Spinner } from "reactstrap";
import { Stack } from "react-bootstrap";

export const CreateDirection = () => {
  const {
    handleSubmit,
    control,
    formState: { errors },
    setError,
  } = useForm({
    defaultValues: {
      name: "",
      code: "",
    },
  });

  const { mutate: createDirection, isPending } = useCreateDirectionMutation(setError);
  const { t } = useTranslation();

  const onSubmit = (data) => {
    createDirection(data);
  };

  return (
    <Stack gap={2}>
      <PageHeader title={t("CREATE_DIRECTION")} />
      <Container fluid>
        <Form onSubmit={handleSubmit(onSubmit)}>
          <DirectionForm control={control} errors={errors} />
          <Button variant="primary" type="submit" disabled={isPending}>
            {isPending ? (
              <>
                <Spinner size="sm" />
                {t("CREATING_DIRECTION")}
              </>
            ) : (
              t("CREATE_DIRECTION")
            )}
          </Button>
        </Form>
      </Container>
    </Stack>
  );
};

